import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import styled from 'styled-components';

import { Loader } from '@ge/components/loader';
import { ScrollingContainer } from '@ge/components/scrolling-container';
import { useCrContractsData } from '@ge/feat-reporting/data-hooks/use-cr-tracker-lock-period';
import { QueryKey } from '@ge/models/constants';

import { CRContractsHeader } from './cr-contracts-header';
import { CRContractsPanel } from './cr-contracts-panel';

const MAContainer = styled.div`
  margin: 20px 50px;
`;

const StyledScrollingContainer = styled(ScrollingContainer)`
  display: flex;
  position: relative;
  flex: 1;
  height: calc(100vh - 270px);
  width: 100%;
`;

export const CRContracts = () => {
  const queryClient = useQueryClient();
  const { data, isLoading: isOverviewLoading } = useCrContractsData();

  useEffect(() => {
    return () => {
      data.forEach((contract) => {
        queryClient.invalidateQueries([QueryKey.CR_TRACKER_LOCK_PERIOD_TABLE, contract.contractId]);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryClient]);

  if (isOverviewLoading) {
    return <Loader />;
  }

  return (
    <MAContainer>
      <CRContractsHeader data={data} />
      <StyledScrollingContainer relative>
        {data.map((contract) => (
          <CRContractsPanel
            key={contract?.contractId}
            contract={contract}
            isOverviewLoading={isOverviewLoading}
          />
        ))}
      </StyledScrollingContainer>
    </MAContainer>
  );
};
